import React from "react";

export const showWizardStepWarningCheckMark = (wizardSelectedValue, featureGroup, cartItems, activeQuoteIndex,
  stepGroups, sqftModalFixState, wizardConflictingSteps, wizardConflictPopupOpened, stepIndex) => {

  const wizardGroup = stepGroups[0]; //wizardSelectedValue.wizardGroup.id
  const isIncompatibleModalOpened = sqftModalFixState.isModalFixOpen && sqftModalFixState.id === 'incompatibleCartItems';
  const isIncompatibleWizardGroupExist = wizardConflictingSteps?.some((wizardConflictingStep) => {
    const isMergedWizardGroupFound = Array.isArray(wizardGroup.mergedGroups) && wizardGroup.mergedGroups
      .some(mergedGroup => mergedGroup.id === wizardConflictingStep.wizardGroupId);
    const isMergedWizardGroupFoundByStepIndex = stepIndex === wizardConflictingStep.stepIndex;
    const isMergedWizardGroupFoundById = wizardConflictingStep.wizardGroupId === wizardGroup.id;

    return isMergedWizardGroupFoundById || isMergedWizardGroupFound || isMergedWizardGroupFoundByStepIndex;
  })

  return (isIncompatibleModalOpened || wizardConflictPopupOpened) && isIncompatibleWizardGroupExist
}

const MaterialsWizardWarningCheckMark = () => {
  return (
    <div className="selection-footer-list__item-warning selection-footer-list__item-done--svg">
    </div>
  )
};
export default MaterialsWizardWarningCheckMark
